import { bottomOverlapPx, stackSlots } from './lib/float-stack.mjs';

const BOTTOM_BAR_SELECTORS = ['.wtoy-lottery-draw-bar', '.wgp-draw-bar', '.wgp-batch-bar', '.wtoy-pickset__savebar'];
const FLOAT_STACK_SELECTORS = ['#cta-link', '.gacha-link-fixed', '.wtoy-queue-link-fixed'];
const BASE = 12;
const GAP = 8;

let rafId = null;

/**
 * `offsetParent` 對 `position:fixed` 元素依規範恆為 null(即使確實顯示中)——
 * 本檔量測的三顆浮動按鈕與所有底部 bar 全是 fixed,不能用 offsetParent 判可見性。
 * `offsetWidth`/`offsetHeight` 不受此影響：display:none 時才會是 0。
 */
function isVisible(el) {
    return !!el && (el.offsetWidth > 0 || el.offsetHeight > 0);
}

function recalc() {
    rafId = null;

    const viewportHeight = window.innerHeight;
    const barRects = BOTTOM_BAR_SELECTORS
        .map((selector) => document.querySelector(selector))
        .filter(isVisible)
        .map((el) => {
            const rect = el.getBoundingClientRect();
            return { top: rect.top, bottom: rect.bottom, height: rect.height };
        });

    const offsetPx = bottomOverlapPx(barRects, viewportHeight);
    document.documentElement.style.setProperty('--wtoy-float-offset', `${Math.round(offsetPx)}px`);

    const floatEls = FLOAT_STACK_SELECTORS.map((selector) => document.querySelector(selector));
    const heights = floatEls.map((el) => (isVisible(el) ? el.offsetHeight : 0));
    const slots = stackSlots(heights, { base: BASE, gap: GAP });

    floatEls.forEach((el, i) => {
        if (!el) return;
        el.style.setProperty('--wtoy-float-slot', `${slots[i]}px`);
    });
}

function scheduleRecalc() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(recalc);
}

function init() {
    scheduleRecalc();

    window.addEventListener('load', scheduleRecalc);
    window.addEventListener('resize', scheduleRecalc);
    window.addEventListener('orientationchange', scheduleRecalc);
    document.addEventListener('wtoy:float-stack-changed', scheduleRecalc);

    const observedBars = new Set();
    const resizeObserver = new ResizeObserver(scheduleRecalc);

    function observeNewBars() {
        const present = new Set(
            BOTTOM_BAR_SELECTORS.map((selector) => document.querySelector(selector)).filter(Boolean)
        );

        observedBars.forEach((el) => {
            if (!present.has(el)) {
                resizeObserver.unobserve(el);
                observedBars.delete(el);
            }
        });

        present.forEach((el) => {
            if (!observedBars.has(el)) {
                observedBars.add(el);
                resizeObserver.observe(el);
            }
        });
    }

    observeNewBars();

    const mutationObserver = new MutationObserver(() => {
        observeNewBars();
        scheduleRecalc();
    });
    mutationObserver.observe(document.body, { childList: true });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
